<script>
    export let color = "info";
    export let icon = "question-circle";
    export let text = "";
</script>
<div class="tag {color}">
    <i class="fa fa-{icon}"></i>
    {text}
</div>

<style>
    td .tag {
    margin-left: -10px;
}

.tag {
    border: 0;
    border-radius: 20px;
    transition: 0.3s ease-in-out;
    padding: 7px 6px;
    text-align: center;
    font-weight: bold;
    font-size: 90%;
    display: flex;
    background-color: #7DCAE5;
    place-content: center;
    margin: 0;
    max-width: 130px;
}

.tag i{
    margin-right: 5px;
    margin-top: 2px
}

@media(max-width: 1500px) {
    .button {
        padding: 6px 8px;
        font-size: 0.7rem
    }
}

@media(max-width: 1380px) {
    .tag {
        padding: 4px 6px;
        font-size: 0.65rem;
    }
}

.tag.info {
    background-color: #6ab8f7;
    color: var(--text-color);
}

.tag.success {
    background-color: var(--success);
    color: white;
}

.tag.warning {
    background: var(--warning);
    color: var(--text-color)
}

.tag.danger {
    background: var(--danger);
    color: white;
}
</style>